import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { FilterPipe } from './portfolio/filter.pipe';
import { EntrepriseComponent } from './entreprise/entreprise.component';
import { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { PortfolioService } from './portfolio.service';

const appRoutes: Routes = [
  { path: ':id', component: EntrepriseComponent },
  { path: '', component: PortfolioComponent },
];
@NgModule({
  declarations: [
    AppComponent,
    PortfolioComponent,
    FilterPipe,
    EntrepriseComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, { useHash: true })
  ],
  providers: [PortfolioService],
  bootstrap: [AppComponent]
})
export class AppModule { }
